import Vue from "vue"
import VueI18n from "vue-i18n"

import * as locales from "@/assets/data/locales"

// Load default plugin values from app.config file overrided by storage
import config from "@/app.config"
import store from "@/store"

Vue.use(VueI18n)

export default new VueI18n({
  lazy: true,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  messages: locales,
  ...config.plugins.i18n,
  locale: store.state.app.locale
})
